import Plyr from 'plyr';
import Vue from 'vue';

Vue.component('video-component', {
    data() {
        return {
            video: null,
            isPlaying: false,
        };
    },

    mounted() {
        this.setupVideo();
    },

    methods: {
        setupVideo() {
            this.video = new Plyr(this.$refs.video, {
                settings: [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'fullscreen',
                ],
            });

            if (!this.video) return;

            this.video.on('play', () => {
                this.isPlaying = true;
            });

            this.video.on('pause', () => {
                this.isPlaying = false;
            });

            this.video.on('seeking', () => {
                this.isPlaying = true;
            });

            this.video.on('ended', () => {
                this.isPlaying = false;
            });
        },

        playVideo() {
            this.video.play();
            this.isPlaying = true;
        },
    },
});
